module.exports = __webpack_public_path__ + "805ca87c6b932004c7a511ce87548df6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-cowboy.png
// module id = 1899
// module chunks = 0